import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  SelectPicker,
  Button,
  Icon,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function ProjectNameWidget({ onSubmitSearchSubProject, ...props }) {
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (!props?.schema?.mainProject?.value) {
      setValue(props.schema.mainProject.name)
    }
  }, [props.schema])

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <Row>
          <Col xs={4} sm={4} md={4}>
            {formSchema.label}
            <ControlLabel
              className={classNames(
                'style-text-lable',
                isRequired(formSchema.mainProject.validators) && 'required'
              )}
            >
              {formSchema.mainProject.label}
            </ControlLabel>
          </Col>
          <Col xs={20} sm={20} md={20}>
            <ErrorMessage error={errors.mainProject} />
            <Controller
              name={formSchema.mainProject.name}
              control={control}
              defaultValue={formSchema.mainProject.value}
              rules={isValidators(formSchema.mainProject.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.mainProject.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={true}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={4} sm={4} md={4}></Col>
          <Col xs={20} sm={20} md={20}>
            <IconButton
              appearance="primary"
              icon={
                <Icon className="fill-color" icon="search" style={{ backgroundColor: '#2ab086' }} />
              }
              style={{ backgroundColor: '#2ab086' }}
              onClick={handleSubmit(onSubmitSearchSubProject)}
            >
              ค้นหา
            </IconButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
